import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-578b5057"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "after-details-card"
}
const _hoisted_2 = {
  key: 0,
  class: "top-box"
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "top-left" }
const _hoisted_5 = {
  key: 0,
  class: "amount-text"
}
const _hoisted_6 = {
  key: 1,
  class: "avatar"
}
const _hoisted_7 = { class: "avatar-right" }
const _hoisted_8 = { class: "avatar-title" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "text-title" }
const _hoisted_11 = {
  key: 3,
  class: "img-box"
}
const _hoisted_12 = { class: "img-content" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "log-value" }, "View", -1))


import { useRoute, useRouter } from 'vue-router';
import AfterGoodsCard from './afterGoodsCard.vue'
import KiliButton from '@/components/KiliButton.vue'
import { Toast } from 'vant'

export default /*#__PURE__*/_defineComponent({
  __name: 'afterDetailsCardNew',
  props: {
  /** 售后单操作记录模块 */
  detailData: {
    type: Array,
    default: () => []
  },
  /** 是否可以编辑用户退换货发货方式的地址 */
  isEditAddress: {
    type: Boolean,
    default: false
  }
},
  emits: ['logistics','contactClick','logInfo'],
  setup(__props, { emit }) {

const prop = __props



const router = useRouter()
const route = useRoute()

const handleBtn = (num: any) => {
  router.push(`/logistics/${num}`)
}
// 复制售后服务号
const handleCopy = (text: any) => {
  let input = document.createElement('input') // 直接构建input
  input.value = text // 设置内容
  document.body.appendChild(input) // 添加临时实例
  input.select() // 选择实例内容
  document.execCommand('copy') ? Toast('replicated') : ''
  document.body.removeChild(input)
}
const setAvatar = (data: number) => {
  // 1-买家；2-卖家；3-客服；9-系统
  const avatarObj = {
    1: 'https://image.kilimall.com/lite/new_wap/default/avatar.png',
    2: 'https://image.kilimall.com/lite/new_wap/default/shop.png',
    3: 'https://image.kilimall.com/lite/new_wap/default/logo.png',
    9: 'https://image.kilimall.com/lite/new_wap/default/logo.png'
  }
  return avatarObj[data]
}
const handleContact = () => {
 emit('contactClick')
}
const clickLogInfo = () => {
  emit('logInfo')
}
const setTime = (time:any) => {
  return common.tiemstap(time * 1000)
}

return (_ctx: any,_cache: any) => {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_cell = _resolveComponent("van-cell")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.detailData, (item) => {
    return (_openBlock(), _createElementBlock(_Fragment, null, [
      (!item.isCell)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (!item.isAvatar)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(item.title), 1),
                  _createElementVNode("div", _hoisted_4, [
                    (item.showAmount)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(item.amount), 1))
                      : _createCommentVNode("", true),
                    (item.showBtn)
                      ? (_openBlock(), _createBlock(KiliButton, {
                          key: 1,
                          plain: "",
                          round: "",
                          icon: "chat-o",
                          textColor: '#E14646',
                          bordersColor: '#E14646',
                          title: "Contact Seller",
                          onClick: handleContact
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_van_image, {
                    round: "",
                    fit: "cover",
                    width: "0.96rem",
                    height: "0.96rem",
                    src: setAvatar(item.avatar.operator_role)
                  }, null, 8, ["src"]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(item.avatar.title), 1),
                    _createElementVNode("span", null, _toDisplayString(setTime(item.avatar.created_at)), 1)
                  ])
                ])),
            (item.goodsData)
              ? (_openBlock(), _createBlock(AfterGoodsCard, {
                  key: 2,
                  goodsData: item.goodsData
                }, null, 8, ["goodsData"]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.textData, (text) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (text.label)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["text-main", text.noBetween ? 'not-between' : ''])
                    }, [
                      (text.isShowViewTrack === 2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(text.value), 1))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("p", _hoisted_10, _toDisplayString(text.label) + ":", 1),
                            _createElementVNode("div", {
                              class: _normalizeClass(["text-content", text.noBetween ? 'not-fex-width' : ''])
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["text-msg", item.isRight ? 'left-text' : ''])
                              }, _toDisplayString(text.value), 3),
                              (text.showCopy)
                                ? (_openBlock(), _createBlock(KiliButton, {
                                    key: 0,
                                    plain: "",
                                    round: "",
                                    textColor: '#666666',
                                    bordersColor: '#999999',
                                    title: "Copy",
                                    class: "view-track",
                                    onClick: ($event: any) => (handleCopy(text.value))
                                  }, null, 8, ["onClick"]))
                                : _createCommentVNode("", true),
                              (text.isShowViewTrack === 1)
                                ? (_openBlock(), _createBlock(KiliButton, {
                                    key: 1,
                                    class: "view-track min-width-btn",
                                    plain: "",
                                    round: "",
                                    textColor: '#44B35B',
                                    bordersColor: '#44B35B',
                                    title: "view track",
                                    onClick: ($event: any) => (handleBtn(text.value))
                                  }, null, 8, ["onClick"]))
                                : _createCommentVNode("", true)
                            ], 2)
                          ], 64))
                    ], 2))
                  : _createCommentVNode("", true)
              ], 64))
            }), 256)),
            (item.fileList)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.fileList, (file) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(_component_van_image, {
                        width: "1.38rem",
                        height: "1.38rem",
                        src: file.content,
                        fit: "cover"
                      }, null, 8, ["src"])
                    ]))
                  }), 256))
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createBlock(_component_van_cell, {
            key: 1,
            class: "log-info",
            center: "",
            title: item.title,
            "is-link": "",
            onClick: clickLogInfo
          }, {
            "right-icon": _withCtx(() => [
              _hoisted_13,
              _createVNode(_component_van_icon, {
                name: "arrow",
                color: "#4481e5"
              })
            ]),
            _: 2
          }, 1032, ["title"]))
    ], 64))
  }), 256))
}
}

})